<template>
  <div class="w-full flex flex-col items-center justify-center">
    <div v-if="label">
      {{ label }}
    </div>
    <div
      class="flex h-1 justify-center items-center relative w-full overflow-hidden">
      <div ref="indicator"
        class="z-10 left-0 absolute indicator h-1 bg-purple-500 duration-500 ease-linear rounded-xl">
      </div>
      <div ref="track" class="z-0 absolute track w-full h-1 bg-purple-200">
      </div>
      <div ref="stopIndicator"
        class="absolute right-0 bg-purple-500 w-1 h-1 rounded-full stop-indicator">
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { watch, ref, onMounted } from 'vue'

const props = withDefaults(defineProps<{
  current?: number
  start?: number
  end?: number
  indeterminate?: boolean
  label?: string
}>(), {
  current: 0,
  start: 0,
  end: 100,
  indeterminate: false
})


const indicator = ref<HTMLElement | null>(null)
const track = ref<HTMLElement | null>(null)
const stopIndicator = ref<HTMLElement | null>(null)

const updateProgressBar = () => {
  if (!indicator.value || !track.value || !stopIndicator.value) {
    return
  }

  if (props.indeterminate) {
    let big = true
    let reset = true
    let l = 0
    let w = 0
    setInterval(() => {
      // move the stop indicator to the left
      // make the progress bar width between 25% and 50%
      l += 75
      w += big ? 75 : -10

      if (reset) {
        l = 0
        w = 0
        big = true
        indicator.value?.classList.toggle('transition-none', true)
        indicator.value?.classList.toggle('transition-all', false)
        indicator.value?.style.setProperty('left', '0%')
        indicator.value?.style.setProperty('width', '0%')
        reset = false
        return
      }

      // transform translateX
      indicator.value?.classList.toggle('transition-all', true)
      indicator.value?.classList.toggle('transition-none', false)
      indicator.value?.style.setProperty('left', `${l}%`)
      indicator.value?.style.setProperty('width', `${w}%`)
      big = !big

      if (l >= props.end) {
        reset = true
      }

    }, 500)
    return
  }

  const progress = (props.current - props.start) / (props.end - props.start)

  // Mettre à jour les variables CSS sur l'élément indicator
  indicator.value.style.setProperty('--progress', `${progress * 100}%`)
}

watch(() => props.current, () => {
  updateProgressBar()
})

onMounted(() => {
  updateProgressBar()
})
</script>

<style scoped>
:root {
  --progress: 0;
}

.indicator {
  width: var(--progress);
  max-width: 100%;
}

.stop-indicator {
  left: var(--progress);
}
</style>